<template>
  <IconLucideCircleDot />
</template>
